/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAPCLONEREASON } from './IAPCLONEREASON';
import {
    IAPCLONEREASONFromJSON,
    IAPCLONEREASONFromJSONTyped,
    IAPCLONEREASONToJSON,
} from './IAPCLONEREASON';
import type { IAPCURRENCY } from './IAPCURRENCY';
import {
    IAPCURRENCYFromJSON,
    IAPCURRENCYFromJSONTyped,
    IAPCURRENCYToJSON,
} from './IAPCURRENCY';
import type { IAPPROPOSALSTATUS } from './IAPPROPOSALSTATUS';
import {
    IAPPROPOSALSTATUSFromJSON,
    IAPPROPOSALSTATUSFromJSONTyped,
    IAPPROPOSALSTATUSToJSON,
} from './IAPPROPOSALSTATUS';
import type { ProposalOverviewScenarioViewModel } from './ProposalOverviewScenarioViewModel';
import {
    ProposalOverviewScenarioViewModelFromJSON,
    ProposalOverviewScenarioViewModelFromJSONTyped,
    ProposalOverviewScenarioViewModelToJSON,
} from './ProposalOverviewScenarioViewModel';

/**
 * 
 * @export
 * @interface ProposalOverviewViewModel
 */
export interface ProposalOverviewViewModel {
    /**
     * 
     * @type {boolean}
     * @memberof ProposalOverviewViewModel
     */
    locked?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProposalOverviewViewModel
     */
    statusId?: string;
    /**
     * 
     * @type {string}
     * @memberof ProposalOverviewViewModel
     */
    productName?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProposalOverviewViewModel
     */
    productNames?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ProposalOverviewViewModel
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalOverviewViewModel
     */
    partyId: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalOverviewViewModel
     */
    clonedFromProposalNumber?: number;
    /**
     * 
     * @type {IAPCLONEREASON}
     * @memberof ProposalOverviewViewModel
     */
    cloneReason?: IAPCLONEREASON;
    /**
     * 
     * @type {string}
     * @memberof ProposalOverviewViewModel
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof ProposalOverviewViewModel
     */
    dateCreated: Date;
    /**
     * 
     * @type {IAPPROPOSALSTATUS}
     * @memberof ProposalOverviewViewModel
     */
    status?: IAPPROPOSALSTATUS;
    /**
     * 
     * @type {Date}
     * @memberof ProposalOverviewViewModel
     */
    expiryDate: Date;
    /**
     * 
     * @type {IAPCURRENCY}
     * @memberof ProposalOverviewViewModel
     */
    currency?: IAPCURRENCY;
    /**
     * 
     * @type {number}
     * @memberof ProposalOverviewViewModel
     */
    proposalLumpSumValue?: number;
    /**
     * 
     * @type {number}
     * @memberof ProposalOverviewViewModel
     */
    proposalRecurringValue?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProposalOverviewViewModel
     */
    advancedGuarantee?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProposalOverviewViewModel
     */
    clientName?: string;
    /**
     * 
     * @type {Array<ProposalOverviewScenarioViewModel>}
     * @memberof ProposalOverviewViewModel
     */
    scenarios?: Array<ProposalOverviewScenarioViewModel>;
    /**
     * 
     * @type {number}
     * @memberof ProposalOverviewViewModel
     */
    selectedScenarioId?: number;
    /**
     * 
     * @type {Date}
     * @memberof ProposalOverviewViewModel
     */
    lastOpened?: Date;
}

/**
 * Check if a given object implements the ProposalOverviewViewModel interface.
 */
export function instanceOfProposalOverviewViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "partyId" in value;
    isInstance = isInstance && "dateCreated" in value;
    isInstance = isInstance && "expiryDate" in value;

    return isInstance;
}

export function ProposalOverviewViewModelFromJSON(json: any): ProposalOverviewViewModel {
    return ProposalOverviewViewModelFromJSONTyped(json, false);
}

export function ProposalOverviewViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProposalOverviewViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'locked': !exists(json, 'Locked') ? undefined : json['Locked'],
        'statusId': !exists(json, 'StatusId') ? undefined : json['StatusId'],
        'productName': !exists(json, 'ProductName') ? undefined : json['ProductName'],
        'productNames': !exists(json, 'ProductNames') ? undefined : json['ProductNames'],
        'id': json['Id'],
        'partyId': json['PartyId'],
        'clonedFromProposalNumber': !exists(json, 'ClonedFromProposalNumber') ? undefined : json['ClonedFromProposalNumber'],
        'cloneReason': !exists(json, 'CloneReason') ? undefined : IAPCLONEREASONFromJSON(json['CloneReason']),
        'description': !exists(json, 'Description') ? undefined : json['Description'],
        'dateCreated': (new Date(json['DateCreated'])),
        'status': !exists(json, 'Status') ? undefined : IAPPROPOSALSTATUSFromJSON(json['Status']),
        'expiryDate': (new Date(json['ExpiryDate'])),
        'currency': !exists(json, 'Currency') ? undefined : IAPCURRENCYFromJSON(json['Currency']),
        'proposalLumpSumValue': !exists(json, 'ProposalLumpSumValue') ? undefined : json['ProposalLumpSumValue'],
        'proposalRecurringValue': !exists(json, 'ProposalRecurringValue') ? undefined : json['ProposalRecurringValue'],
        'advancedGuarantee': !exists(json, 'AdvancedGuarantee') ? undefined : json['AdvancedGuarantee'],
        'clientName': !exists(json, 'ClientName') ? undefined : json['ClientName'],
        'scenarios': !exists(json, 'Scenarios') ? undefined : ((json['Scenarios'] as Array<any>).map(ProposalOverviewScenarioViewModelFromJSON)),
        'selectedScenarioId': !exists(json, 'SelectedScenarioId') ? undefined : json['SelectedScenarioId'],
        'lastOpened': !exists(json, 'LastOpened') ? undefined : (new Date(json['LastOpened'])),
    };
}

export function ProposalOverviewViewModelToJSON(value?: ProposalOverviewViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Locked': value.locked,
        'StatusId': value.statusId,
        'ProductName': value.productName,
        'ProductNames': value.productNames,
        'Id': value.id,
        'PartyId': value.partyId,
        'ClonedFromProposalNumber': value.clonedFromProposalNumber,
        'CloneReason': IAPCLONEREASONToJSON(value.cloneReason),
        'Description': value.description,
        'DateCreated': (value.dateCreated.toISOString()),
        'Status': IAPPROPOSALSTATUSToJSON(value.status),
        'ExpiryDate': (value.expiryDate.toISOString()),
        'Currency': IAPCURRENCYToJSON(value.currency),
        'ProposalLumpSumValue': value.proposalLumpSumValue,
        'ProposalRecurringValue': value.proposalRecurringValue,
        'AdvancedGuarantee': value.advancedGuarantee,
        'ClientName': value.clientName,
        'Scenarios': value.scenarios === undefined ? undefined : ((value.scenarios as Array<any>).map(ProposalOverviewScenarioViewModelToJSON)),
        'SelectedScenarioId': value.selectedScenarioId,
        'LastOpened': value.lastOpened === undefined ? undefined : (value.lastOpened.toISOString()),
    };
}

